<template>
  <div class="lang-switcher">
    <div class="selected" @click="toggleDropdown">
      <span><v-img style="width: 25px; height: 25px; display: flex; align-items: center; border-radius: 100%;" :src="currentLang?.flag" alt="Flag" /></span>
      <span class="arrow" :class="{ open: isOpen }"><v-icon>mdi-menu-down</v-icon></span>
    </div>

    <ul v-if="isOpen" class="dropdown">
      <li
        v-for="lang in languages"
        :key="lang.code"
        @click="selectLang(lang)"
        :class="{ active: currentLang.code === lang.code }"
      >
        <span><v-img style="width: 25px; height: 25px; display: flex; align-items: center; border-radius: 100%;" :src="lang.flag" alt="Flag" /></span>
        <span>{{ lang.label }}</span>
      </li>
    </ul>
    <div id="google_translate_element" style="display: none"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      currentLang: { code: "lo", label: "ລາວ", flag: "https://upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Laos.svg" },
      languages: [
        { code: "lo",    label: "ລາວ",    flag: "https://upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Laos.svg" },
        { code: "th",    label: "ไทย",    flag: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg" },
        { code: "en",    label: "English", flag: "https://upload.wikimedia.org/wikipedia/commons/7/77/Flag_of_the_United_States_and_United_Kingdom.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=original" },
        { code: "zh-CN", label: "中文",   flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_the_People%27s_Republic_of_China.svg/960px-Flag_of_the_People%27s_Republic_of_China.svg.png?_=20250417144606" },
      ],
    };
  },

  mounted() {
    this.readCurrentLang();
    this.loadGoogleTranslate();
    document.addEventListener("click", this.closeOutside);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.closeOutside);
    delete window.googleTranslateElementInit;
  },

  methods: {
    // ✅ Read cookie on mount to restore selected flag after reload
    readCurrentLang() {
      try {
        const match = document.cookie.match(/googtrans=\/lo\/([^;]+)/);
        if (match) {
          const code = match[1];
          const found = this.languages.find((l) => l.code === code);
          if (found) this.currentLang = found;
        }
      } catch (e) {
        console.warn("Read cookie error:", e);
      }
    },

    loadGoogleTranslate() {
      window.googleTranslateElementInit = () => {
        try {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: "lo",
              includedLanguages: "lo,th,en,ru,zh-CN",
              autoDisplay: false,
            },
            "google_translate_element"
          );
        } catch (e) {
          console.warn("Google Translate init failed:", e);
        }
      };

      if (document.getElementById("google-translate-script")) {
        if (window.google && window.google.translate) {
          window.googleTranslateElementInit();
        }
        return;
      }

      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      script.onerror = (e) => console.warn("Failed to load Google Translate:", e);
      document.body.appendChild(script);
    },

    selectLang(lang) {
      this.currentLang = lang;
      this.isOpen = false;
      this.setGoogleTranslateCookie(lang.code);
    },

    // ✅ Cookie-based approach — no cross-origin errors
    setGoogleTranslateCookie(langCode) {
      try {
        if (langCode === "lo") {
          // Clear cookie to restore original Lao language
          document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + location.hostname;
        } else {
          // Set cookie: /sourcelang/targetlang
          document.cookie = `googtrans=/lo/${langCode}; path=/`;
          document.cookie = `googtrans=/lo/${langCode}; path=/; domain=${location.hostname}`;
        }
        // Reload page so Google Translate picks up the new cookie
        location.reload();
      } catch (e) {
        console.warn("Cookie translate error:", e);
      }
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },

    closeOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style>
/* Hide Google Translate UI */
body > .skiptranslate      { display: none !important; }
body                       { top: 0 !important; }
.goog-te-banner-frame      { display: none !important; }
</style>

<style scoped>
.lang-switcher {
  position: relative;
  display: inline-block;
  font-family: sans-serif;
  user-select: none;
}

.selected {
  font-weight: 700;
  color: #86181C;
  display: flex;
  align-items: center;
  padding: 5px 5px;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  min-width: 45px;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  transition: border-color 0.2s;
}

.selected:hover {
  border-color: #aaa;
}

.arrow {
  font-size: 12px;
  transition: transform 0.2s;
  color: #888;
}

.arrow.open {
  transform: rotate(180deg);
}

.dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  min-width: 150px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 9999;
}

.dropdown li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.15s;
}

.dropdown li:hover {
  background: #f5f5f5;
}

.dropdown li.active {
  background: #eef4ff;
  font-weight: 600;
  color: #2563eb;
}
</style>